// Camelcase a dashed string, ie do-thing => doThing
export const camelize = (str: string) => str.replace(/-(\w)/g, (_, letter) => letter.toUpperCase());

/* eslint-disable no-param-reassign, guard-for-in, no-restricted-syntax */
// Set multiple css properties on an element `el` by
// passing in a `style` object that defines what properties
// to set and their value
export const setStyles = (el: HTMLDivElement, styles: Record<string, string>) => {
  for (const property in styles) {
    el.style[property as any] = styles[property];
  }
};
/* eslint-enable no-param-reassign, guard-for-in, no-restricted-syntax */

// Get the current style property value for the given element
export const getStyle = (el: HTMLElement, styleProp: string) => {
  if (document.defaultView && document?.defaultView?.getComputedStyle) {
    return document.defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
  }
  return el.style[camelize(styleProp) as any];
};

const getOverflow = (el: HTMLDivElement) => {
  return [el.clientWidth < el.scrollWidth, el.clientHeight < el.scrollHeight];
};

// Determine the font-size to set on the element `el` that will
// allow the first child of that element to fill the maximum height
// and width without causing overflow
export const getFillSize = (
  el: HTMLDivElement | undefined,
  isWidthOnly?: boolean,
  minFontSize = 12,
  maxFontSize = 200
) => {
  if (!el) return minFontSize;

  let fontSize = minFontSize;

  const step = 3;
  let isComplete = false;

  while (!isComplete) {
    el.style.fontSize = `${fontSize}px`;
    const [overflowWidth, overflowHeight] = getOverflow(el);

    if (!isWidthOnly && (overflowHeight || overflowWidth)) {
      if (fontSize <= minFontSize) {
        fontSize = minFontSize;
        isComplete = true;
      } else {
        fontSize -= step;
        isComplete = true;
      }
    } else if (isWidthOnly && overflowWidth) {
      fontSize -= step;
      isComplete = true;
    } else if (fontSize >= maxFontSize) {
      fontSize = maxFontSize;
      isComplete = true;
    } else if (!isComplete) {
      fontSize += step;
    }
  }
  return fontSize;
};
